import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useMatch, useNavigate } from "react-router-dom";
import { Segmented } from "antd";
import { observer } from "mobx-react-lite";

import { MemberTeamsTab } from "../components/teammanage/MemberTeamsTab";
import { OwnTeamTab } from "../components/teammanage/OwnTeamTab";
import { teamStore } from "../stores/teamStore";
import { usePageTitle } from "../utils/usePageTitle";

import "./TeamManagePage.css";

export const TeamManagePage = observer(function TeamManagePage() {
  const { t } = useTranslation();
  usePageTitle(t("team.teamManagement"));
  const navigate = useNavigate();
  const isMember = useMatch("/teammanage/member");
  const activeTab = isMember ? "member" : "owner";

  useEffect(() => {
    teamStore.loadOwnTeam();
    teamStore.loadMemberTeams();
  }, []);

  useEffect(() => {
    if (activeTab === "owner") {
      void teamStore.loadOutgoingInvitations();
    } else {
      void teamStore.loadIncomingInvitations();
    }
  }, [activeTab]);

  return (
    <div className="page team-manage-page">
      <h1>{t("team.teamManagement")}</h1>
      <Segmented
        size="large"
        value={activeTab}
        onChange={(val) => navigate(`/teammanage/${val}`)}
        options={[
          { value: "owner", label: t("team.ownerTab") },
          {
            value: "member",
            label: (
              <span className="team-manage-page__tab-label">
                {t("team.memberTab")}
                {teamStore.incomingInvitations.length > 0 && (
                  <span
                    className="team-manage-page__tab-invitation-badge"
                    aria-label={t("team.pendingInvitations")}
                    title={t("team.pendingInvitations")}
                  />
                )}
              </span>
            ),
          },
        ]}
        className="team-manage-page__nav"
      />
      <div className="team-manage-page__content">
        <div style={{ display: activeTab === "owner" ? undefined : "none" }}>
          <OwnTeamTab />
        </div>
        <div style={{ display: activeTab === "member" ? undefined : "none" }}>
          <MemberTeamsTab />
        </div>
      </div>
    </div>
  );
});
